// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import CovidRoom from '../_raw/service/icon_covid_room.svg';
import withIconProps from '../withIconProps';

export default withIconProps(CovidRoom);
